import { render, staticRenderFns } from "./HearingTestWeb.vue?vue&type=template&id=0060d5b2"
import script from "./HearingTestWeb.vue?vue&type=script&lang=js"
export * from "./HearingTestWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports